import template from './campus-row.html';

const CampusRowComponent = {
    bindings: {
        campus: '<',
    },
    template
};

export default CampusRowComponent;



// WEBPACK FOOTER //
// ./app/components/client-admin/campus-row/campus-row-component.js